import styled, { css } from 'styled-components'
import { Container } from './Avatar'

const StackedAvatars = styled.div<{ noBorder?: boolean, disableHide?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${Container} {
    &:not(:first-child) {
      margin-left: -6px;

      @media screen and (max-width: 767px) {
        display: none;

        ${props => props.disableHide && css`
          display: flex;
        `}
      }
    }

    ${props => props.noBorder && css`
      box-shadow: none;
      border: none;
    `}
  }
`

export default StackedAvatars